/* eslint-disable react/display-name */
import BootstrapTable from 'react-bootstrap-table-next';
import { useMemo } from 'react';
import PlainTablePlaceholder from '../../results/common/plain-table-placeholder/PlainTablePlaceholder';
import PropTypes from 'prop-types';
import ExpandableTableRow from './ExpandableTableRow';

const ExpandableTable = ({ columns, data }) => {

    const nonExpandable = data.reduce((acc, item) => {
        !item.children && acc.push(item.pid);
        return acc;
    }, []);

    const expandRow = {
        renderer: (row) => {
            return row.children?.map((item) => {
                return <ExpandableTableRow process={item}></ExpandableTableRow>;
            });
        },
        expandHeaderColumnRenderer: () => {
            return <b></b>;
        },
        /* eslint-disable react/prop-types */
        expandColumnRenderer: ({ expanded, expandable }) => {
            if (expanded) {
                return (
                    <i className="icon-angle-up" />
                );
            }

            if (!expandable) {
                return <></>;
            }
            return (
                <i className="icon-angle-down" />
            );
        },
        showExpandColumn: true,
        expandByColumnOnly: true,
        nonExpandable
    };

    const tableDom = useMemo(() => {
        if (!data) {
            return <PlainTablePlaceholder numberOfColumns={4} />;
        }

        return <BootstrapTable
            keyField='pid'
            data={data}
            columns={columns}
            expandRow={expandRow}
        />;

    }, [data, expandRow]);

    return <>
        {tableDom}
    </>;

};

ExpandableTable.propTypes = {
    data: PropTypes.array,
    columns: PropTypes.array,
};

export default ExpandableTable;
